module.exports = __webpack_public_path__ + "img/404038.e89eccb0.png";